import { render, staticRenderFns } from "./Third_mobile.vue?vue&type=template&id=23c3c1f8&scoped=true&"
import script from "./Third_mobile.vue?vue&type=script&lang=js&"
export * from "./Third_mobile.vue?vue&type=script&lang=js&"
import style0 from "./Third_mobile.vue?vue&type=style&index=0&id=23c3c1f8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23c3c1f8",
  null
  
)

export default component.exports